/**
 * Returns the show more label for the tags
 */
export const buildShowMoreLabel = (count: number, showMoreLabel = '') =>
    count ? [`+${count}`, showMoreLabel].filter(Boolean).join(' ') : '';
